module.exports = __webpack_public_path__ + "img/ysgj_046@2x.15dd60b7.png";